<template>
  <ProSpaceRightPanel
    v-if="ids.length > 0"
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @clear="clearPanel"
    @edit="editPanel"
    @delete="deletePanel"
    @show-history="showHistoryPanel"
  >
    <template v-if="ids.length === 1" v-slot:center>
      <ProSpacePanelBlock :header="headerTDMs">
        <template #header>
          <ProSpaceAction
            v-if="checkEditAccess(tDM)"
            :text="$t('editItemTxt')"
            @click="editPanel"
          />
        </template>
        <ProSpacePanelBlockList :list="content" />
      </ProSpacePanelBlock>
    </template>
    <template v-if="ids.length === 1" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
} from "@prospace/prospace-components-library";
import { TDMService } from "../../../services/TDMService";
import { mapGetters } from "vuex";
import { getAMorPM } from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
export default {
  name: "TDMPanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    ids: {
      type: Array,
      required: true,
    },
    filterAccessDots: {
      type: Function,
    },
    checkEditAccess: {
      type: Function,
    },
    checkAccess: {
      type: Function,
    },
  },
  data() {
    return {
      tDM: null,
      tDMService: new TDMService(),
      loading: false,
      hasError: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime",
    }),
    headerTDMs() {
      return {
        title: this.$t("overview"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    tabs() {
      return [{ name: this.$t("overview"), isActive: true }];
    },
    header() {
      if (this.tDM) {
        return {
          title: this.tDM.value,
          id: this.ids[0],
          status: this.getStatus(this.tDM.status),
          options: this.getAccessDots(this.options),
          showCounter: false,
        };
      }
      return {
        title: this.$t("itemsSelected"),
        counter: this.ids.length,
        showCounter: true,
        cleareble: true,
      };
    },
    content() {
      if (this.tDM) {
        return [
          [
            {
              title: this.$t("code"),
              text: this.tDM.code,
            },
          ],
          [
            {
              title: this.$t("tDMValue"),
              text: this.tDM.value,
            },
          ],
        ];
      }
      return [];
    },
    contentBottom() {
      if (this.tDM) {
        return [
          [
            {
              title: this.$t("createdByTxt"),
              text: this.tDM.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.tDM.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text:
                this.getFormatDateTime(this.tDM.createdAt) +
                " " +
                getAMorPM(this.tDM.createdAt, this.userinfo?.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text:
                this.getFormatDateTime(this.tDM.lastUpdated) +
                " " +
                getAMorPM(this.tDM.lastUpdated, this.userinfo?.timeFormat),
            },
          ],
        ];
      }
      return [];
    },
  },
  mounted() {
    this.update();
  },
  watch: {
    ids() {
      this.update();
    },
  },
  methods: {
    getAccessDots(options) {
      return this.filterAccessDots ? this.filterAccessDots(options, this.tDM) : options;
    },
    update() {
      this.hasError = false;
      try {
        this.getTDM();
      } catch (e) {
        this.hasError = true;
      }
    },
    getTDM() {
      if (this.ids.length === 1) {
        this.loading = true;
        this.tDMService.get(this.ids[0]).then((res) => {
          this.tDM = res.data;
          this.loading = false;
        });
      }
      this.tDM = null;
    },
    getStatus(status) {
      if (!status) return;
      return {
        type: status === "ACTIVE" ? "success" : "danger",
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
      };
    },
    clearPanel() {
      this.$emit("clear");
    },
    editPanel() {
      this.$emit("edit", this.tDM);
    },
    deletePanel() {
      this.$emit("delete", this.tDM);
    },
    showHistoryPanel() {
      this.$emit("history", this.tDM);
    },
  },
};
</script>

<style scoped></style>
